
const common = {
  "nav.productos": "Productos",
  "nav.proceso": "Proceso",
  "nav.empresa": "Empresa",
  "nav.contactar": "Contactar",

  "hero.title": "Calidad costarricense sin fronteras",
  "hero.subtitle": "Exportadores de productos agrícolas procesados con estándares internacionales",
  "hero.cta": "Solicitar Información",
  "hero.badge": "Exportando a 4 continentes",

  "experience.tag": "Experiencia y Trayectoria",
  "experience.title": "+30 años de experiencia en el mercado",
  "experience.subtitle": "Nuestro equipo suma más de tres décadas trabajando mano a mano con productores locales y desarrollando soluciones alimentarias para mercados internacionales.",
  "experience.story.title": "Nuestra Experiencia",
  "experience.story": "Nuestro equipo de trabajo cuenta con más de 30 años de experiencia en el sector agroindustrial, construyendo relaciones directas con productores locales y desarrollando procesos de producción que garantizan calidad, inocuidad y trazabilidad en cada producto.",
  "experience.backing.title": "Nuestro respaldo incluye:",
  "experience.backing.item1": "Más de 30 años de experiencia en el sector agroindustrial",
  "experience.backing.item2": "Relación directa con productores locales y abastecimiento estable",
  "experience.backing.item3": "Procesos de calidad, inocuidad y trazabilidad",
  "experience.backing.item4": "Experiencia exportadora y cumplimiento de requisitos internacionales",
  "experience.backing.item5": "Flexibilidad en presentaciones y volúmenes según el cliente",
  "experience.who.title": "Quiénes Somos",
  "experience.who.desc1": "Somos una empresa agroindustrial orientada a la producción de alimentos envasados que utiliza materia prima comprada directamente a familias de agricultores locales.",
  "experience.who.desc2": "Cada alimento que producimos y envasamos representa el trabajo conjunto entre nuestra empresa y los productores que forman parte de nuestra cadena de valor.",
  "experience.who.desc3": "Nuestro compromiso es transformar la riqueza agrícola de Costa Rica en productos de alta calidad listos para exportación.",
  "experience.icon.producers": "Productores Locales",
  "experience.icon.export": "Exportación",
  "experience.icon.quality": "Calidad",
  "experience.icon.traceability": "Trazabilidad",

  "value.tag": "Por Qué Elegirnos",
  "value.title": "Calidad, Sostenibilidad y Confianza",
  "value.subtitle": "Trabajamos directamente con familias productoras costarricenses para ofrecer soluciones alimentarias innovadoras",
  "value.b1.title": "Abastecimiento Responsable",
  "value.b1.desc": "Compramos directamente a familias agricultoras locales, garantizando trazabilidad y comercio justo",
  "value.b2.title": "Estándares Internacionales",
  "value.b2.desc": "Planta procesadora moderna con controles de calidad que cumplen normativas globales",
  "value.b3.title": "Experiencia Exportadora",
  "value.b3.desc": "Presencia consolidada en Sudamérica, Norteamérica, Europa y Asia",
  "value.b4.title": "Presencia Importante",
  "value.b4.desc": "Amplia presencia en cadenas estadounidenses como Walmart, HEB, Whole Foods, Publix...",

  "features.tag": "Nuestras Capacidades",
  "features.title": "Infraestructura y Versatilidad de Producto",
  "features.f1.title": "Planta de Procesamiento",
  "features.f1.desc": "Instalaciones equipadas con tecnología y sistemas de control de calidad certificados para garantizar inocuidad y trazabilidad",
  "features.f1.p1": "Certificaciones internacionales",
  "features.f1.p2": "Controles de temperatura",
  "features.f1.p3": "Laboratorio interno",
  "features.f2.title": "Proceso Estandarizado",
  "features.f2.desc": "Contamos con una planta equipada para el envasado y enlatado de piña y palmito, con líneas de producción organizadas que garantizan un proceso continuo y eficiente. Nuestro sistema operativo está diseñado para manejar altos volúmenes de pedidos manteniendo el orden",
  "features.f2.p1": "Flujo de producción estructurado desde recepción hasta sellado final",
  "features.f2.p2": "Protocolos operativos que aseguran consistencia y eficiencia en cada lote",
  "features.f2.p3": "",
  "features.f3.title": "Opciones de Empaque Flexibles",
  "features.f3.desc": "Lata y Vidrio disponibles según preferencias del cliente y requisitos del mercado destino",
  "features.f3.p1": "Etiquetado personalizado",
  "features.f3.p2": "Marca blanca",
  "features.f3.p3": "Diferentes tamaños",

  "social.tag": "Nuestro Origen",
  "social.title": "¿Por Qué Costa Rica?",
  "social.desc": "Costa Rica es reconocida mundialmente por su biodiversidad, excelencia agrícola y compromiso con la sostenibilidad. Nuestras operaciones están ubicadas en Sarapiquí, una región conocida por su tierra fértil y rico entorno natural.",
  "social.f1.title": "Líder Mundial en Biodiversidad",
  "social.f1.desc": "5% de la biodiversidad en 0.03% de la superficie terrestre",
  "social.f2.title": "Pionera en Sostenibilidad",
  "social.f2.desc": "Compromiso carbono neutral y líder en energía renovable",
  "social.f3.title": "Excelencia Agrícola",
  "social.f3.desc": "Suelos volcánicos fértiles y clima tropical ideal",
  "social.s1.value": "30+",
  "social.s1.label": "AÑOS DE EXPERIENCIA",
  "social.s2.value": "5",
  "social.s2.label": "CONTINENTES SERVIDOS",
  "social.s3.value": "100%",
  "social.s3.label": "COMPRA LOCAL",
  "social.s4.label": "LISTO PARA EXPORTAR",

  "process.tag": "Nuestro Proceso",
  "process.title": "Del Campo al Mundo en 3 Pasos",
  "process.s1.title": "Abastecimiento Local",
  "process.s1.desc": "Compramos materia prima directamente de productores costarricenses, asegurando frescura y trazabilidad desde el origen",
  "process.s2.title": "Procesamiento Certificado",
  "process.s2.desc": "Transformamos y empacamos bajo estándares internacionales de calidad e inocuidad alimentaria",
  "process.s3.title": "Exportación Global",
  "process.s3.desc": "Entregamos a tiempo en los principales mercados internacionales con logística especializada",

  "products.tag": "Nuestros Productos",
  "products.title": "Portafolio Diversificado de Exportación",
  "products.note": "Certificados para manejo y procesamiento de palmito y piña orgánica.",

  "products.cat1.title": "Palmito",
  "products.cat1.opt1": "Palmito Triturado",
  "products.cat1.opt2": "Palmito Arroz",
  "products.cat1.opt3": "Pasta Cabello de Ángel de Palmito",

  "products.cat2.title": "Piña",
  "products.cat2.opt1": "Piña Triturada",
  "products.cat2.opt2": "Piña en Trozos",
  "products.cat2.opt3": "Piña en Rodajas",

  "products.cat3.title": "Palmito Entero",
  "products.cat3.opt1": "Palmito Entero",
  "products.cat3.opt2": "Palmito Doble",
  "products.cat3.opt3": "Palmito en Lasaña",
  "products.cat3.opt4": "Palmito en trozos",

  "pricing.title": "Soluciones Personalizadas para Cada Cliente",
  "pricing.desc": "Entendemos que cada mercado y socio comercial tiene necesidades únicas. Nuestros precios y condiciones se adaptan según volumen, presentación, empaque y destino.",
  "pricing.p1": "Cotizaciones basadas en volumen y frecuencia",
  "pricing.p2": "Flexibilidad en presentaciones y empaques",
  "pricing.p3": "Asesoría para optimizar costos logísticos",
  "pricing.cta": "Solicitar Cotización",

  "cta.title": "¿Listo para Exportar Calidad Costarricense?",
  "cta.desc": "Construyamos una relación comercial de largo plazo basada en confianza y excelencia",
  "cta.button": "Contactar Ahora",
  "cta.email": "O escríbenos a",
  "cta.badge1": "Respuesta rápida",
  "cta.badge2": "Asesoría personalizada",
  "cta.badge3": "Muestras disponibles",

  "footer.tagline": "Exportadores costarricenses de alimentos procesados premium",
  "footer.productos": "PRODUCTOS",
  "footer.empresa": "EMPRESA",
  "footer.contacto": "CONTACTO",
  "footer.porQueElegirnos": "Por Qué Elegirnos",
  "footer.capacidades": "Capacidades",
  "footer.porQueCR": "Por Qué Costa Rica",
  "footer.proceso": "Nuestro Proceso",
  "footer.productosLink": "Productos",
  "footer.soluciones": "Soluciones",
  "footer.contactoLink": "Contacto",
  "footer.productPalmito": "Palmito",
  "footer.productPina": "Piña",
  "footer.derechos": "© 2025 PPP Exports. Todos los derechos reservados.",

  "modal.title": "Contáctenos",
  "modal.nombre": "Nombre completo *",
  "modal.empresa": "Empresa *",
  "modal.email": "Correo electrónico *",
  "modal.telefono": "Teléfono",
  "modal.pais": "País *",
  "modal.mensaje": "Mensaje *",
  "modal.placeholder": "Cuéntenos sobre sus necesidades de importación...",
  "modal.chars": "caracteres",
  "modal.success": "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
  "modal.error": "Hubo un error al enviar el mensaje. Por favor, intente nuevamente.",
  "modal.sending": "Enviando...",
  "modal.send": "Enviar Mensaje"
};

export default common;
